import { IUser } from './../../common/types/User'
import { defineStore } from 'pinia'

const CURRENT_USER_STORAGE = 'currentUser'

export const useUserStore = defineStore('user', {
	state: () => ({
		currentUser: (localStorage[CURRENT_USER_STORAGE]
			? JSON.parse(localStorage[CURRENT_USER_STORAGE])
			: null) as IUser | null,
	}),

	actions: {
		setCurrentUser(currentUser: IUser | null) {
			currentUser
				? localStorage.setItem(CURRENT_USER_STORAGE, JSON.stringify(currentUser))
				: localStorage.removeItem(CURRENT_USER_STORAGE)
			this.currentUser = currentUser
		},
	},
})
